import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./auth";
import ConsentGate from "../components/ConsentGate";

export function ProtectedRoute({ children, roles }) {
  const { user } = useAuth();
  const location = useLocation();

  if (user === null) {
    return (
      <div className="flex h-screen items-center justify-center bg-[var(--c-bg)]">
        <div className="text-sm text-zinc-500" data-testid="loading-state">Laden...</div>
      </div>
    );
  }
  if (user === false) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  if (roles && !roles.includes(user.role)) {
    if (user.role === "admin") return <Navigate to="/admin" replace />;
    if (user.role === "job_coach") return <Navigate to="/dashboard" replace />;
    if (user.role === "coachee") return <Navigate to="/tests" replace />;
    return <Navigate to="/login" replace />;
  }
  // AVG consent gate — only relevant for coachees AND only for routes that
  // are NOT the privacy pages themselves (so a coachee can still read the
  // privacy statement / log out without first having to accept).
  if (
    user.role === "coachee"
    && !location.pathname.startsWith("/privacy")
    && !location.pathname.startsWith("/mijn-privacy")
  ) {
    return <ConsentGate>{children}</ConsentGate>;
  }
  return children;
}
